export default "<div class=\"updates-container\"></div>\n";